import errors from './errors/index.js';
import translation from './translation/index.js';
const zh_tw = {
    translation,
    errors,
};
export default Object.freeze(zh_tw);
